import { EAgencies } from "../types/common.types";
import { EIconNames } from "../types/iconNames";

export const companiesTabsOptions = [
  {
    name: "Webcom",
    iconName: EIconNames.WEBCOM_LOGO_SHORT,
    value: String(EAgencies.Webcom_BY),
  },
  {
    name: "Webcom RU",
    iconName: EIconNames.WEBCOM_LOGO_SHORT,
    value: String(EAgencies.Webcom_RU),
  },
  {
    name: "iContext",
    iconName: EIconNames.ICONTEXT,
    value: String(EAgencies.IContext),
  },
  {
    name: "Все",
    value: null,
  },
];
